export const sidebarItems = {
    sysadmin: [
        { text: "Panel de control", to: "/sysadmin/home/dashboard", icon: "dashboard" },
        { text: "Usuarios", to: "/sysadmin/home/users", icon: "group" },
        { text: "Cerrar sesión", to: "/sysadmin/home/logout", icon: "sensor_door" }
    ],
    salesrep: [
        { text: "Tickets", to: "/salesrep/home/tickets", icon: "receipt_long" },
        { text: "Historial", to: "/salesrep/home/history", icon: "manage_search" },
        { text: "Cerrar sesión", to: "/salesrep/home/logout", icon: "sensor_door" }
    ],
    supervisor: [
        { text: "Tickets", to: "/supervisor/home/tickets", icon: "receipt_long" },
        { text: "Clientes", to: "/supervisor/home/clients", icon: "work" },
        { text: "Aditivos", to: "/supervisor/home/additives", icon: "hive" },
        { text: "Componentes", to: "/supervisor/home/components", icon: "home_repair_service" },
        { text: "Equipos", to: "/supervisor/home/equipments", icon: "construction" },
        { text: "Historial", to: "/supervisor/home/history", icon: "manage_search" },
        { text: "Cerrar sesión", to: "/supervisor/home/logout", icon: "sensor_door" }
    ],
    administrative: [
        { text: "Tickets", to: "/administrative/home/tickets", icon: "receipt_long" },
        { text: "Clientes", to: "/administrative/home/clients", icon: "work" },
        { text: "Aditivos", to: "/administrative/home/additives", icon: "hive" },
        { text: "Componentes", to: "/administrative/home/components", icon: "home_repair_service" },
        { text: "Equipos", to: "/administrative/home/equipments", icon: "construction" },
        { text: "Historial", to: "/administrative/home/history", icon: "manage_search" },
        { text: "Cerrar sesión", to: "/administrative/home/logout", icon: "sensor_door" }
    ],
    technician: [
        { text: "Tickets", to: "/technician/home/tickets", icon: "receipt_long" },
        { text: "Cerrar sesión", to: "/technician/home/logout", icon: "sensor_door" }
    ]
};